import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useHasPermission, usePermissionsLoaded } from '../packages/permission-guard';

/**
 * RequirePermissionRoute — gates a route subtree behind a single
 * resource:action permission. Unlike hiding a nav link, this blocks direct URL
 * access: a user without the permission is redirected to /dashboard.
 *
 * Renders nothing until permissions have loaded, so a permitted user isn't
 * briefly bounced on a hard refresh before their role→permission map arrives.
 * superadmin and admin bypass via useHasPermission.
 */
export function RequirePermissionRoute({ resource, action }: { resource: string; action: string }) {
    const loaded = usePermissionsLoaded();
    const allowed = useHasPermission(resource, action);
    if (!loaded) return null;
    return allowed ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
